import {Component, Inject, Input, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import { Parser } from "json-logic-parser";
import {IPostMessageEventTarget, PostMessageBridgeFactory} from "@tekool/ngx-post-message-angular-9";
import {Guide} from "../../models/guide";
import { CostView } from "../../models/infix-formula/costView";
import {FormControllerService} from "../../services/form-controller/form-controller.service";
import { LanguageControllerService } from "../../services/language-controller/language-controller.service";
import {Store} from "../../services/store.service";
import * as _ from "lodash";
import {ComponentFormulas} from "../../models/component-formulas";
import {DeterminantControllerService} from "../../services/registration-controller/determinant-controller.service";

@Component({
    selector: "formio-formula-builder-section",
    templateUrl: "./formio-formula-builder-section.component.html",
    styleUrls: ["./formio-formula-builder-section.component.scss"],
    providers: [FormControllerService],
})
export class FormioFormulaBuilderSectionComponent implements OnInit {

    public costView: CostView;
    public serviceId: string;
    public componentFormulaId: string;
    public componentKey: string;
    public componentType: string;
    public infixToJsonLogicParser: Parser;
    public determinantMapById: { [key: string]: string } = {};

  public changePrefix: boolean = false;

    constructor(private route: ActivatedRoute, public store: Store, public translate: TranslateService,
                private formControllerService: FormControllerService,
                private determinantService: DeterminantControllerService,
                private languageService: LanguageControllerService,
                @Inject(PostMessageBridgeFactory) private bridgeFactory: PostMessageBridgeFactory) {

        const parentWindow: IPostMessageEventTarget = window.top;
        const iFrame: IPostMessageEventTarget = window;
        translate.setDefaultLang(store.state.common.lang);
        languageService.getLanguages().subscribe(
          (data) => {
            translate.addLangs(data.map((l) => l.code));
          });

        bridgeFactory.makeInstance()
            .setEnableLogging(false)
            .connect(iFrame, parentWindow)
            .makeBridge("FormulaBuilder")
            .makeBridge("UpdateFormula");
        this.infixToJsonLogicParser = new Parser();
        this.costView = new CostView();
        this.costView.idAsSlugMode = true; // use keys as slugs
    }

    public ngOnInit() {
        this.route.queryParamMap.subscribe((queryParams) => {
          this.componentFormulaId = queryParams.get("componentFormulaId");
          this.componentKey = queryParams.get("key");
          this.componentType = queryParams.get("compType");
          this.route.params.subscribe((params) => {
            this.serviceId = params.serviceId;
            this.store.state.common.serviceId = params.serviceId;
            this.getList();
            this.costView.formulaLoaded = true;
            this.getServiceDeterminantKeyName();
          });
        });
    }

  public getServiceDeterminantKeyName() {
    this.determinantService.getServiceDeterminantIdAndName(this.serviceId).subscribe(
      (data) => Object.assign(this.determinantMapById, data),
    );
  }

    public getList() {
        const opts: any = {
          isCopyValueFrom: false,
          filterByType: "number,datetime,datagrid,editgrid,select,textfield,textarea,checkbox,email",
          ignoreMultiple: true
        };
        this.formControllerService.getServiceFields(this.serviceId, opts).subscribe(
            (data) => {
                data.forEach((field) => {
                  field.title = field.fullName;
                  field.name = field.fullName;
                  field.id = field.fullKey || field.key;
                  field.value = field.fullKey || field.key;
                  this.costView.formFieldsGroup.push(field);
                  if (!this.costView.properties.find( (prop) => prop.id === field.key)) {
                    this.costView.properties.push({id: field.fullKey || field.key, name: field.name, label: field.name, type: field.type ? field.type.toUpperCase() : "" });
                  }
                });
                this.formControllerService.getFormFieldContainer(this.serviceId, this.componentKey).subscribe((otherData) => {
                    if (otherData.prefix && otherData.prefix !== "data") {
                        this.changePrefix = true;
                    }
                    this.costView.propertiesLoaded = true;
                });

            },
        );
    }

    public sendNrOfFormulas(msg: ComponentFormulas): void {
        const message = {
          key: this.componentKey,
          count: msg.formulaRows.length,
          changes: { componentFormulaId: msg.id, formulaRowIds: msg.formulaRows.map((row) => row.id)},
        };
        const messageString: string = JSON.stringify(message);
        window.top.postMessage([{channel: "FormBuilder", message: messageString}], "*");
    }

}
